export class PropertyChangedEvent {
}
//# sourceMappingURL=propertyChangedEvent.js.map